// extracted by mini-css-extract-plugin
export var billingAddress = "_rf-g";
export var contactInfo = "_rf-d";
export var customerInfoContainer = "_rf-c";
export var customerInfoContainerMobile = "_rf-h";
export var customerInfoRow = "_rf-a";
export var customerInfoSection = "_rf-b";
export var fullWidthDividerMobile = "_rf-i";
export var imageContainer = "_rf-1";
export var paymentMethod = "_rf-e";
export var priceText = "_rf-6";
export var priceTextMobile = "_rf-7";
export var product = "_rf-0";
export var productImage = "_rf-2";
export var productInfo = "_rf-4";
export var productMobile = "_rf-9";
export var productTitle = "_rf-8";
export var quantityBadge = "_rf-3";
export var quantityText = "_rf-5";
export var shippingAddress = "_rf-f";